import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { Router } from "@angular/router";
/**
 * VerifyComponent
 */
let UploadDocumentScreenComponent = class UploadDocumentScreenComponent {
    constructor(httpClient, webSettingsService, sanitizer, themeService, router) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.secondColor = '';
        this.backColor = '';
        this.linkColor = '';
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.successColor = '';
        this.borderRadiusLarger = '';
        this.selectedFiles = [];
        this.filesToUpload = [];
        this.fileSize = 2;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        if (this.user == null || this.user == undefined) {
            this.router.navigateByUrl('/login');
        }
        if (!(this.user.user_settings.check_status_verbose_id == 'KYC_RESIDENT_CHECK_FAILD_NOT_EU' ||
            this.user.user_settings.check_status_verbose_id == 'KYC_ADDITIONAL_DOCUMENTATION')) {
            this.router.navigateByUrl('/');
        }
    }
    fileChange(event) {
        this.filesToUpload = this.toArray(event.target.files);
        if (this.selectedFiles.length == 0) {
            this.selectedFiles = this.filesToUpload;
        }
        else {
            for (let i = 0; i < this.filesToUpload.length; i++) {
                for (let j = 0; j < this.selectedFiles.length; j++) {
                    if (this.filesToUpload[i].name === this.selectedFiles[j].name) {
                        break;
                    }
                    if (j === this.selectedFiles.length - 1) {
                        this.selectedFiles = this.selectedFiles.concat(this.filesToUpload[i]);
                    }
                }
            }
        }
        document.getElementById('my-file').value = '';
        this.validateFiles();
    }
    toArray(fileList) {
        return Array.prototype.slice.call(fileList);
    }
    validateFiles() {
        for (let i = 0; i < this.selectedFiles.length; i++) {
            let fileExtension = this.selectedFiles[i].name.split('.').pop();
            let allowed = this.checkFileExtension(fileExtension);
            if (this.selectedFiles[i].size > 1024 * 1024 * this.fileSize || !allowed) {
                this.fileError = true;
                return;
            }
        }
        this.fileError = false;
    }
    checkFileExtension(fileExtension) {
        let allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf', 'gif', 'JPG', 'JPEG', 'PNG', 'PDF', 'GIF'];
        let allowed = allowedExtensions.includes(fileExtension);
        return allowed;
    }
    removeFile(index) {
        this.selectedFiles.splice(index, 1);
        this.validateFiles();
    }
    roundNumber(num, places) {
        return Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
    }
    submitDocuments() {
        return __awaiter(this, void 0, void 0, function* () {
            let formData = new FormData();
            const files = this.selectedFiles;
            for (let i = 0; i < files.length; i++) {
                formData.append(files[i].name, files[i]);
            }
            let documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const temporaryFileReader = new FileReader();
                return new Promise((resolve) => {
                    temporaryFileReader.onload = () => {
                        resolve(temporaryFileReader.result);
                        const tempFile = {
                            name: file.name,
                            content: temporaryFileReader.result
                        };
                        documentationFiles.push(tempFile);
                    };
                    temporaryFileReader.readAsDataURL(file);
                });
            };
            for (let i = 0; i < files.length; i++) {
                yield readUploadedFileAsDataURL(files[i]);
            }
            this.httpClient.post('user/userkycdocymentation', { user_id: 1, documentation_files: documentationFiles }).subscribe((success) => {
                this.router.navigateByUrl('pending');
            });
        });
    }
};
UploadDocumentScreenComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router }
];
UploadDocumentScreenComponent = __decorate([
    Component({
        selector: 'ecd-pending-screen',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./upload-document-screen.component.html")).default
    })
], UploadDocumentScreenComponent);
export { UploadDocumentScreenComponent };
